import styled from 'styled-components';

export const AreaMessageConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  p {
    margin: 0;
  }
`;

export const ContainerModalConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: ${({ theme }) => theme.white};
  border-radius: 8px;
  padding: 1rem;

  h6 {
    font-weight: bold;
    color: #000;
    text-align: center;
  }

  &&& {
    .MuiFormControl-root {
      overflow: inherit;
    }

    .MuiInputBase-root {
      border-radius: 3px !important;
      height: 40px !important;
      padding-top: 5px !important;
      padding-left: 0px !important;
    }

    .MuiInputBase-input {
      padding: 6px 10px 4px !important;
    }

    .MuiInputLabel-outlined {
      transform: translate(14px, 14px) scale(1);
    }

    .MuiInputLabel-outlined.MuiInputLabel-shrink {
      transform: translate(14px, -6px) scale(0.75);
    }
  }
`;
